/*
Cascade by Pixelarity
pixelarity.com | hello@pixelarity.com
License: pixelarity.com/license
*/

const skel = require('./skel.min.js')
require('./skel-layout.min.js')
require('./jquery.scrolly.min.js')
require('./jquery.scrollex.min.js')
require('./pswp.js');

(function ($) { // eslint-disable-line
  skel.breakpoints({
    xlarge: '(max-width: 1680px)',
    large: '(max-width: 1280px)',
    medium: '(max-width: 980px)',
    small: '(max-width: 736px)',
    xsmall: '(max-width: 480px)'
  })

  /**
   * Custom carousel for Altitude.
   * @return {jQuery} jQuery object.
   */
  $.fn._carousel = function (options) {
    var $window = $(window) // eslint-disable-line no-unused-vars
    var $this = $(this)

    // Handle no/multiple elements.
    if (this.length === 0) {
      return $this
    }

    if (this.length > 1) {
      for (var i = 0; i < this.length; i++) {
        $(this[i])._slider(options)
      }
      return $this
    }

    // Vars.
    var current = 0
    var pos = 0
    var lastPos = 0
    var slides = []
    var $slides = $this.children('article')
    var intervalId
    var isLocked = false
    var i = 0 // eslint-disable-line no-redeclare

    // Functions.
    $this._switchTo = function (x, stop) {
      // Handle lock.
      if (isLocked || pos === x) {
        return
      }

      isLocked = true

      // Stop?
      if (stop) {
        window.clearInterval(intervalId)
      }

      // Update positions.
      lastPos = pos
      pos = x

      // Hide last slide.
      slides[lastPos].removeClass('visible')

      // Finish hiding last slide after a short delay.
      window.setTimeout(function () {
        // Hide last slide (display).
        slides[lastPos].hide()

        // Show new slide (display).
        slides[pos].show()

        // Show new new slide.
        window.setTimeout(function () {
          slides[pos].addClass('visible')
        }, 25)

        // Unlock after sort delay.
        window.setTimeout(function () {
          isLocked = false
        }, options.speed)
      }, options.speed)
    }

    // Slides.
    $slides
      .each(function () {
        var $slide = $(this)
        // Add to slides.
        slides.push($slide)
        // Hide.
        $slide.hide()
        i++
      })

    // Nav.
    $this
      .on('click', '.next', function (event) {
        // Prevent default.
        event.preventDefault()
        event.stopPropagation()

        // Increment.
        current++

        if (current >= slides.length) {
          current = 0
        }

        // Switch.
        $this._switchTo(current)
      })
      .on('click', '.previous', function (event) {
        // Prevent default.
        event.preventDefault()
        event.stopPropagation()

        // Decrement.
        current--

        if (current < 0) {
          current = slides.length - 1
        }

        // Switch.
        $this._switchTo(current)
      })

    // Initial slide.
    slides[pos]
      .show()
      .addClass('visible')

    // Bail if we only have a single slide.
    if (slides.length === 1) {
      return // eslint-disable-line
    }
  }

  $(function () {
    var $window = $(window)
    var $body = $('body')
    var $header = $('#header')
    var $banner = $('#banner')

    // Disable animations/transitions until the page has loaded.
    $body.addClass('is-loading')

    $window.on('load', function () {
      window.setTimeout(function () {
        $body.removeClass('is-loading')
      }, 100)
    })

    // IE: Various fixes.
    if (skel.vars.browser === 'ie') {
      $body.addClass('is-ie')
    }

    // Prioritize "important" elements on medium.
    skel.on('+medium -medium', function () {
      $.prioritize(
        '.important\\28 medium\\29',
        skel.breakpoint('medium').active
      )
    })

    // Menu.
    $('#menu')
      .append('<a href="#menu" class="close"></a>')
      .appendTo($body)
      .panel({
        delay: 500,
        hideOnClick: true,
        hideOnSwipe: true,
        resetScroll: true,
        resetForms: true,
        side: 'right'
      })

    // Header.
    if ($banner.length > 0 && $header.hasClass('alt')) {
      $window.on('resize', function () {
        $window.trigger('scroll')
      })

      $banner.scrollex({
        bottom: $header.outerHeight(),
        terminate: function () {
          $header.removeClass('alt')
        },
        enter: function () {
          $header.addClass('alt')
        },
        leave: function () {
          $header.removeClass('alt')
        }
      })
    }

    // Images.
    $('.image[data-position]').each(function () {
      var $this = $(this)
      var $img = $this.children('img')

      // Polyfill object-fit.
      if (!skel.canUse('object-fit')) {
        // Apply img as background.
        $this
          .css('background-image', 'url("' + $img.attr('src') + '")')
          .css('background-position', $this.data('position'))
          .css('background-size', 'cover')
          .css('background-repeat', 'no-repeat')

        // Hide img.
        $img
          .css('opacity', '0')

        return // eslint-disable-line
      }
    })

    // Scrolly.
    $('.scrolly').scrolly({
      offset: function () {
        return $header.outerHeight() - 2
      }
    })

    $('.scrolly-middle').scrolly({
      anchor: 'middle',
      offset: function () {
        return $header.outerHeight() - 2
      }
    })

    // Spotlights.
    $('.spotlight').scrollex({
      top: '30vh',
      bottom: '30vh',
      delay: 25,
      initialize: function () {
        $(this).addClass('is-inactive')
      },
      terminate: function () {
        $(this).removeClass('is-inactive')
      },
      enter: function () {
        $(this).removeClass('is-inactive')
      }
    })

    // Carousels.
    $('.carousel')._carousel({ speed: 350 })
  })
})(jQuery) // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./assets/js/main.js